let Schedule = Backbone.Model.extend({
    defaults: {
        items: null,
        modified: false,
    },

    initialize: function () {
        this.set('items', new ScheduleItemList(unpackList(this.get('items'), CreateScheduleItemFromAttributes)));
    },

    getItems: function() {
        return this.get('items');
    },

    addItem: function(item) {
      this.getItems().add(item);
    },

    forDay: function(day) {
        let scheduleForDay = this.getItems().filter((x) => x.getDay() === day);
        scheduleForDay.sort(function (a, b) {
            return a.getStartTime() - b.getStartTime();
        });
        return scheduleForDay;
    },

    totalHoursForType: function(scheduleType) {
        let total = 0;
        this.getItems().each(function (scheduleItem) {
            if (scheduleItem.getType() === scheduleType ||
                (scheduleItem.getType() === ScheduleType.workHome && scheduleType === ScheduleType.workOffice)) {
                total += scheduleItem.getDuration();
            }
        });
        return Math.round(total / 60.0);
    },

    lookupById: function(id) {
        return this.getItems().find((item) => item.cid === id);
    }
});
